import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'

import {
  TextAligning,
  TextBox,
  TextBoxColors,
  TextBoxTypes,
} from 'atoms/TextBox'

export interface ITextBoxMaxLine1Body4SecondaryProps extends ITextBoxProps {}

export const TextBoxMaxLine1Body4Secondary = ({
  title,
  color = TextBoxColors.SURFACE_DARK_7,
  font = TextBoxTypes.Body4,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Body4SecondaryProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
